import { css } from '@emotion/react';
import { rwdrc2 } from '~/configs/rwdrc';
export const createDesktopCss = (rootCss) => css `
    @media screen and (min-width: ${rwdrc2.desktop.min + 'px'}) {
      ${rootCss}
    }
  `;
